/* Community and public profile screens
 *
 * Moved verbatim from currencykeep_2026-08-03.html, lines 867-920.
 * The body below is byte-identical to the original; only the import
 * block above and the export block below were added. (Phase 1, Step 2.)
 */

import { CATALOG, GLABEL, gradeLabel, isCol, isObs } from './catalog.js'
import { cardSub, cardTitle, chipBody, isErr, typeLabel } from './community.js'
import { SORTLABEL, frNum, noteYear } from './filters.js'
import { FILTER_DEFS, applyFilters, filterNote, yearOf } from './note-filters.js'
import { searchMatch } from './note-search.js'
import { chip } from './render.js'
import { $, cat, pubCat, state } from './state.js'

/* ⚠ A STRANGER'S CUSTOM ENTRY IS TEXT — his register item of 2026-09-27,
 * built 2026-10-04: db/009 publishes its `fr`, `denom`, `fd` and
 * `section`, and the card title and sub line are built from them, so
 * both are escaped where they are printed. The public note's `desc` too,
 * on his catch: `pubCat` falls back to `cat()`, which resolves the
 * owner's own custom entry with its typed (or read) state in `desc`.
 * And every USERNAME it prints, his ruling the same day: the client cleans
 * one to [a-z0-9_], but no database constraint does (the register). */
const escH=s=>String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");

function vCommunity(){
  const q=(state.cSearch||"").trim().toLowerCase();
  let profs=(state.pubProfiles||[]).slice();
  if(q)profs=profs.filter(p=>p.username.toLowerCase().includes(q));
  const cards=profs.map(p=>`<button class="card" data-viewuser="${escH(p.username)}">
      <div class="chip acc plogo" id="plogo_${escH(p.username)}"><b style="font-size:19px">${escH((p.username[0]||"?").toUpperCase())}</b></div>
      <div class="body"><div class="t1"><span class="fr">@${escH(p.username)}</span>${p.demo?'<span class="pill year" style="background:#3C4E68">sample</span>':(p.username===state.username?'<span class="pill grade">you</span>':"")}</div>
        <div class="desc">${p.notes.length} note${p.notes.length!==1?"s":""}</div></div>
      <div class="right"><div class="est" style="font-size:13px;color:var(--gold)">View ›</div></div></button>`).join("");
  return `<div style="padding-top:8px"></div>
    <div class="rowhead"><h2>Community</h2><span class="count">${profs.length} public</span></div>
    ${state.username?`<div class="profhead"><div class="banner" id="myBanner"><button class="bnedit" data-photoadd="banner">✎ Banner</button></div><div class="profid"><div class="chip acc plogo" id="myLogo"><b style="font-size:20px">${escH((state.username[0]||"?").toUpperCase())}</b></div><div class="profmeta"><div class="pn">@${escH(state.username)}</div><button class="lgedit" data-photoadd="logo">Change logo</button></div></div></div>`:`<div class="profprompt">Set a username in your Vault to add a logo and banner.</div>`}
    <div class="search" style="margin-bottom:14px"><span class="mag">⌕</span><input id="cq" placeholder="Search a collector's username" value="${escH(state.cSearch||"")}"></div>
    ${cards||`<div class="empty" style="padding:30px 20px"><p>No collectors match.${state.isPublic?"":" Flip your collection to Public in the Vault to appear here."}</p></div>`}
    <div class="hint">Public collections show which notes a collector owns — never values or what anyone paid.</div>`;
}
function vPublicProfile(){
  const p=(state.pubProfiles||[]).find(x=>x.username===state.viewUser);
  if(!p)return `<button class="back" data-navback="community">‹ Community</button><div class="empty" style="padding:40px"><p>That collection isn't available right now.</p></div>`;
  const q=(state.pSearch||"").trim().toLowerCase();
  /* ⚠⚠ `pubCat` IS THE QUICK-ADD FIX, 2026-08-29. A custom note's `c` is
   * `CUSTOM:…`, and `BY_SID` on a stranger's device has never held
   * another collector's custom sid — so `cat(x.c)` was undefined and
   * `.filter(o=>o.n)` dropped the note BEFORE any photo logic ran. Three
   * of Jesse's four holdings were invisible to a stranger for a year.
   * ⚠ It was written inline here and at `filters.js` and was about to be
   * written a THIRD time for the note detail; it lives in `state.js` now
   * so the three cannot drift. All readers of a public profile's notes
   * must go through it. */
  let list=p.notes.map(x=>({x,n:pubCat(x)})).filter(o=>o.n);
  /* ⚠ The profile runs the SAME code as the vault — see views-vault.js.
   * Two copies of a predicate is how one of them drifts. */
  /* ⚠ Other's step 6, his B: a stranger's custom note filters by its public year (`filterNote`) */
  list=applyFilters(list,def=>state[def.p],o=>filterNote(o.n,o.x.y));
  /* ⚠ STOP C (C3): the SAME haystack and exact-place rule as the vault
   * (`note-search.js`); the profile passes the public note's own year and
   * grade. Two copies of a search string is how one of them drifted. */
  if(q)list=list.filter(o=>searchMatch(q,o.n,{year:o.x.y,grade:GLABEL[o.x.g]||o.x.g,labelOf:typeLabel},CATALOG));
  /* ⚠ Same rule as the vault — see views-vault.js. The public note's own
   * `y` wins, then a recovered `series` year, then `desc`. */
  const yv=o=>(yearOf(o.x.y,o.n)||0);
  const so=state.pSort;
  if(so==="fr_asc")list.sort((a,b)=>frNum(a.n.fr)-frNum(b.n.fr));
  else if(so==="fr_desc")list.sort((a,b)=>frNum(b.n.fr)-frNum(a.n.fr));
  else if(so==="year_asc")list.sort((a,b)=>(yv(a)||9999)-(yv(b)||9999));
  else if(so==="year_desc")list.sort((a,b)=>(yv(b)||-1)-(yv(a)||-1));
  /* ⚠⚠ THE CARD BECAME A BUTTON IN STEP 9, 2026-08-29. It was
   * `<div class="card" style="cursor:default">` — DELIBERATELY inert,
   * because there was nowhere to go: the public note-detail screen did
   * not exist, and the chip carried `id="pth_<hid>"` only so a
   * photograph could be injected into it.
   *
   * ⚠ `data-pubnote` CARRIES THE HOLDING ID, NOT AN INDEX. The list is
   * filtered and sorted by four pieces of state above, so a positional
   * reference would point at a different note the moment anybody typed
   * in the search box. */
  /* ⚠⚠ THE `EPQ/PPQ` PILL AND THE DETAIL ROW ARE PUBLIC ON HIS RULING,
   * 2026-09-21: the designation shows on a stranger's profile *"the same
   * way the grade does."* It arrives as `x.q`, a boolean, from BOTH
   * producers of this shape (`snapshot` and `rowToPublicNote`).
   *
   * ⚠⚠⚠ OFF RENDERS NOTHING AT ALL — no pill, no row, no "No". That is
   * deliberate and it is the one place this differs from the grade,
   * which always prints: **off is the default on every note in the
   * catalogue, so printing it would put a word on 11,614 notes to say
   * nothing had happened.** ⚠ The cost, recorded because it is a real
   * one: absent and off are indistinguishable to a stranger here. That
   * is acceptable ONLY because a stranger has no action to take on the
   * difference — unlike the app's own reader, where "absent, not empty"
   * is load-bearing (`Fr 380`'s missing `backType`).
   *
   * ⚠ It says `EPQ/PPQ`, never one of the two words, because the stored
   * boolean cannot tell them apart — his ruling 3, and the same reason
   * the owner's own toggle sub-label stopped naming a word. */
  const cards=list.map(o=>{const x=o.x,n=o.n;
    return `<button class="card" data-pubnote="${x.hid}">
      <div class="chip ${isErr(n)?"err":""}${isCol(n)?" col":""}" ${x.hasF&&x.hid?`id="pth_${x.hid}"`:""}>${chipBody(n)}</div>
      <div class="body">
        <div class="t1"><span class="fr">${escH(cardTitle(n,x.y))}</span></div>
        <div class="desc">${escH(cardSub(n,x.y))}</div>
        <div class="pills" style="margin-top:6px">${x.g?`<span class="pill grade">${gradeLabel(x.g)}</span>`:""}${x.q?`<span class="pill qual">EPQ/PPQ</span>`:""}</div>
      </div>
      <div class="right"><div class="est" style="font-size:13px;color:var(--gold)">View ›</div></div></button>`;}).join("");
  const active=[];
  for(const def of FILTER_DEFS){const v=state[def.p];if(v&&v!=="All")active.push([def.key,def.key==="denom"?v+" notes":v]);}
  if(so!=="added")active.push(["sort",SORTLABEL[so]]);
  const activeHtml=active.length?`<div class="activefilters">${active.map(a=>`<span class="afchip">${a[1]}<span class="x" data-rmfilter="${a[0]}">✕</span></span>`).join("")}<button class="afclear" data-clearfilters>Clear all</button></div>`:"";
  return `<button class="back" data-navback="community">‹ Community</button>
    <div class="profbanner" id="pbanner"></div>
    <div class="hero herob"><div class="chip acc plogo phlogo" id="phlogo"><b style="font-size:22px">${escH((p.username[0]||"?").toUpperCase())}</b></div><div class="fr">@${escH(p.username)}</div><div class="dn">${p.notes.length} note${p.notes.length!==1?"s":""} in this collection</div>${p.username===state.username?'<div class="ds">This is your public collection</div>':""}</div>
    <div class="vsearchrow">
      <div class="search"><span class="mag">⌕</span><input id="pq" placeholder="Search this collection — year, type, Fr#…" value="${escH(state.pSearch||"")}"></div>
      <button class="filterbtn ${active.length?"on":""}" data-openfilters="profile">${active.length?'<span class="dot"></span>':""}Filters</button>
    </div>
    ${activeHtml}
    <div id="pphnotice"></div>
    ${cards||`<div class="empty" style="padding:28px 20px"><p>No notes match.</p><button class="btn sm" data-clearfilters style="margin:14px auto 0">Clear filters</button></div>`}
    <div class="hint">You can see which notes this collector owns — values and cost basis stay private.</div>`;
}

/**
 * ONE NOTE ON SOMEBODY ELSE'S PUBLIC PROFILE — PHASE 4 STEP 9, 2026-08-29.
 *
 * ══ ⚠⚠⚠ THIS IS THE FIRST TIME A BACK PHOTOGRAPH REACHES A STRANGER ══
 *
 * `hasB` appeared NOWHERE outside the vault before this screen — not in
 * `views-community.js`, not in the community hydration in `photos.js`,
 * not in `community-photos.js`. `photos.js` filtered on `x.hasF` and
 * asked for slot `front` only. **Half of every photograph in the bucket
 * was unreachable by anyone but its owner**, which is the same sentence
 * that made the `custom_entry` read path the priority before it.
 *
 * ══ WHAT THIS IS, AS DECIDED ═══════════════════════════════════════
 * Jesse, 2026-08-28: *"the same as his own note detail — two image
 * frames, front and back, both tappable."* So the layout is `vHolding`'s
 * and the difference is everything it LEAVES OUT.
 *
 * ⚠⚠ IT IS A SUBTRACTION FROM `vHolding`, AND THE SUBTRACTED LIST IS THE
 * SAFETY PROPERTY. Every one of these is either an edit affordance that
 * must never reach a stranger's screen, or a private column db/002 keeps
 * out of `public_holdings` by name:
 *
 *   data-photoadd  on BOTH frames — the picker. A stranger tapping a
 *                  frame must not be offered "Add front"
 *   grade tabs     `data-setgrade` writes to the owner's holding
 *   catalog prices `n.g[i]` — money, and `pubCat` does not carry it
 *   cost basis     `cost`      — PRIVATE (db/002)
 *   appraised      `user_value`— PRIVATE
 *   acquired       `acquired_on`— PRIVATE
 *   memo           `personal_note` — PRIVATE, and it is where he types
 *                  serial numbers
 *   Remove         `data-remove` deletes a holding
 *
 * ⚠ THE DATA CANNOT LEAK EVEN IF THIS FUNCTION WERE WRONG — none of
 * those columns is in `public_holdings`, so a stranger's note object has
 * never held them. This list is the SECOND line, not the only one, and
 * it is written out so the next person editing this file knows which
 * omissions are deliberate.
 *
 * ══ ⚠ NO ENLARGE, AND THAT IS A DECISION RATHER THAN AN OMISSION ═════
 * Jesse re-opened the 2026-08-28 bundling on 2026-08-29 and split it
 * 2 + 1: *"Bundling a 6.6 MB-per-tap decision inside a screen-building
 * task does the opposite of what I wanted."* The frames render at
 * `display`; `archive` is several times larger and whether
 * a stranger should ever get it is **its own costing, with the serial
 * -number question attached.** ⚠ DO NOT add a tap-to-zoom here without
 * that decision — see BUILD_NOTES.
 */
function vPublicNote(){
  const p=(state.pubProfiles||[]).find(x=>x.username===state.viewUser);
  const x=p&&(p.notes||[]).find(y=>y.hid===state.pubNote);
  const n=x&&pubCat(x);
  /* ⚠ ONE EXIT FOR THREE DIFFERENT ABSENCES — the profile went private
   * between the tap and the render, the note is not in it, or it does
   * not resolve. A stranger can act on none of them differently, and
   * naming which would describe another collector's data to someone who
   * is not entitled to it. Same reasoning as `vPublicProfile` above. */
  if(!n)return `<button class="back" data-navback="pubprofile">‹ Back</button><div class="empty" style="padding:40px"><p>That note isn't available right now.</p></div>`;
  return `<button class="back" data-navback="pubprofile">‹ @${escH(p.username)}</button>
    <div class="hero"><div class="fr">${escH(cardTitle(n,x.y))}</div><div class="dn">${escH(cardSub(n,x.y))}</div>${n.desc?`<div class="ds">${escH(n.desc)}</div>`:""}</div>
    <div class="field"><label>Photographs</label>
      <div class="photobox"><div id="ppnotice"></div><div class="frames">
        <div class="pframe pubframe" id="ppf_front"><div class="ph"><span class="cam">⧉</span>No front photograph</div><span class="tag">Front</span></div>
        <div class="pframe pubframe" id="ppf_back"><div class="ph"><span class="cam">⧉</span>No back photograph</div><span class="tag">Back</span></div>
      </div></div>
    </div>
    <div class="calc">
      ${x.g?`<div class="r"><span class="lab">Grade</span><span class="mono">${gradeLabel(x.g)}</span></div>`:""}
      ${x.y?`<div class="r"><span class="lab">Series year</span><span class="mono">${x.y}</span></div>`:""}
      ${x.q?`<div class="r"><span class="lab">EPQ / PPQ</span><span class="mono">Yes</span></div>`:""}
    </div>
    <div class="hint">You can see which notes this collector owns — values and cost basis stay private.</div>
    ${state.pubZoom?vPublicZoom(state.pubZoom):""}`;
}

/* ══ ⚠⚠⚠ THE ENLARGE — PHASE 4 STEP 9, THE "+1" OF THE 2 + 1 SPLIT ═══
 *
 * Decided by Jesse 2026-08-29, against the recommendation: a signed-in
 * collector gets the FULL 6000px archive tier from Community. *"The
 * detail IS the point in this hobby — plate varieties, overprints,
 * paper. And on the serial, I'm making the trade knowingly: it's visible
 * to anyone who sees the note at a show."*
 *
 * ⚠ THE COST IS THE DECIDED PART AND IS NOT RE-LITIGATED HERE: several
 * megabytes per tap, against a `display` copy several times smaller.
 *
 * ⚠⚠⚠ THE SIZE AND THE MULTIPLIER ARE PER-NOTE QUANTITIES, NOT TIER
 * PROPERTIES — RETIRED AS A HEADLINE 2026-09-04. Two notes have been
 * measured and they do not agree: `e01c53fb`/front is 6,561,469 B
 * against 1,459,693 B (4.50×); `44c139c1` is 5,126,651 B back and
 * 5,326,319 B front, at 5.20× and 5.15×. ⚠⚠ Each figure is correct for
 * the note it was measured on and for no other. **Never write this as a
 * range** — not "4.5×–5.2×", not "5.1–6.5 MB". Two notes disagreeing is
 * not a distribution. See BUILD_NOTES, item A.
 *
 * ⚠ What this code owes is that the cost is paid ONLY ON A TAP, never on
 * a screen load. `hydratePhotos` asks for `display` to fill the two
 * frames and for `archive` only when `state.pubZoom` names a slot — and
 * `pubnote-check` §2 is the assertion that holds it there. An archive
 * request during hydration would answer the archive-cost question by
 * default from inside a screen, which is the exact thing the 2 + 1 split
 * exists to stop.
 *
 * ⚠⚠ THE STAGE IS NOT BLANK WHILE THE ARCHIVE BYTES ARRIVE. The `display`
 * bytes are already in the cache — they are what the frame behind this
 * overlay is showing — so `hydratePhotos` puts them up immediately and
 * swaps to `archive` when it lands. Costs a Map lookup and nothing on
 * the wire. The alternative is a black stage for several seconds on a
 * phone, which is a tap that looks broken until suddenly it isn't.
 *
 * ⚠⚠⚠ NO DOWNLOAD, NO SHARE, NO SAVE CONTROL, AND THAT IS A DECISION.
 * This is another collector's property. The archive tier is reachable by
 * URL today and that reachability is INTENDED (2026-08-29) — but
 * intending that someone MAY fetch a thing is not the same as building
 * them a button that files it. The subtracted list in `vPublicNote` is
 * the standing shape here, and this overlay adds nothing to it: a close
 * control and, if the fetch fails, a Retry.
 *
 * ⚠ THE SLOT IS READ FROM `state.pubZoom` RATHER THAN PASSED FROM THE
 * FRAME, so the open viewer survives a re-render — `render()` rebuilds
 * this screen's innerHTML on every pass and a viewer held in the DOM
 * alone would vanish on the next one. */
function vPublicZoom(slot){
  const side=slot==="front"?"Front":"Back";
  return `<div class="pvw" id="ppz">
    <div class="pvw-bar">
      <span class="pvw-side">${side}</span>
      <button class="pvw-x" data-ppzclose aria-label="Close">✕</button>
    </div>
    <div class="pvw-stage"><img id="ppz_img" alt="${side} of this note, enlarged"></div>
    <div class="pvw-foot"><div id="ppznotice"></div></div>
  </div>`;
}

export {
  vCommunity,
  vPublicNote,
  vPublicProfile,
}
